<template>
    <Fragment v-if="news.length">
        <div v-for="item in news" v-bind:key="item.id" class="header_news">
            <div class="container">
                <div class="row" :id="'header-news-item-' + item.id">
                    <div class="col cutoff">
                        <a :href="'/news/' + item.slug" class="news_link header_news_link">{{ item.title }}</a>
                    </div>
                    <div class="col-auto">
                        <a
                            href="#"
                            class="btn btn_lg btn_common btn_icononly header_news_close"
                            @click.prevent="close(item.id)"
                        ><i class="f7-icons icon_lg">xmark</i></a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <b-modal v-for="item in popups" hide-footer class="modal modal_details show"
            v-bind:key="item.id"
            :id="'id_news_popup' + item.id"
            :ref="'id_news_popup' + item.id"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
            v-model="show"
            size="xl"
        >

            <template #modal-header="{ close }">
                <h5 class="modal-title title">{{ item.title }}</h5>

                <b-button class="btn btn_lg btn_common btn_icononly" data-dismiss="modal">
                    <i class="f7-icons icon_lg" @click="closePopup(item.id)">xmark</i>
                </b-button>
            </template>

            <template #default="{ hide }">
                <div class="text mt_xxs" v-html="item.content_raw"></div>

                <b-button @click="closePopup(item.id)" type="button" class="btn btn_lg btn_common btn_icontext" data-dismiss="modal">
                    <i class="f7-icons icon_lg">xmark</i> Закрыть сообщение
                </b-button>
            </template>

        </b-modal>

    </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

export default {

    components: { Fragment },

    data: function () {
        return {
            items: [],
            show: true
        };
    },
    methods: {
        close(id) {
            this.$cookies.set('news' + id, 1);
            this.items = [...this.items];
        },
        closePopup(id) {
            this.$cookies.set('news-popup' + id, 1);
            this.items = [...this.items];
        },

    },
    computed: {
        news() {
            return this.items.filter(function(item) {
                return !$cookies.get('news' + item.id);
            });
        },
        popups() {
            let items = this.items.filter(function(item) {
                return item.is_popup && !$cookies.get('news-popup' + item.id);
            });

            if (items.length) {
                return [ items[0] ];
            }

            return [];
        },
    },
    mounted: function() {
        axios.get('/ajax/news').then(({data}) => {
            this.items =[
                ...data.items
            ];

        }).catch((err) => {
            console.error(err)
        });
    }
};
</script>
